import React, { useContext, useReducer } from "react";

import GlobalContext    from "../../isp._comun/contexto/GlobalContext";
import * as TipoDeError from "../../isp._comun/servicios/Errores";

import useHandlerDeComandoConSesionActiva from "../../isp.pantalla.principal/componentes/useHandlerDeComandoConSesionActiva";
import {
    NotificacionToastDeCreacion,
    NotificacionToastDeError,
}                       from "../../isp._comun/componentes/widgets/Notificaciones";

import DataDeRespuestas_Facturacion from "../../isp.servicios.items/DataEstaticaDeRespuestas.json";

import ItemReducer           from "../reductores/ItemReducer";
import * as Action           from "../reductores/acciones/dispatch/_ActionsDispatch";
import CargaDeItemConsultado from "../reductores/acciones/dispatch/CargaDeItemConsultado";
import FinalizarComando      from "../reductores/acciones/dispatch/FinalizarComando";


import DialogItem from "./layouts/DialogItem";
// import { TipoDeItem } from "../../reductores/Constantes";

import ComandoAPI from "./ComandoAPI";
import ComandoRegistrarItem from "./ComandoRegistrarItem";
import ComandoActualizarItem from "./ComandoActualizarItem";

// import ServicioRegistroDeItem from "../../servicios/ServicioRegistroDeItem";
//import ServicioDeActualizacionDeItem from "../../servicios/ServicioDeActualizacionDeItem";
//import ServicioDeQueryDeUnItem from "../../servicios/ServicioDeQueryDeUnItem";


// import CodigoDeError from "../../../all/presentadores/CodigosDeErrorDeRespuestas.json";
// import DataDeRespuestas_Comun from "../../../all/presentadores/DataEstaticaDeRespuestas.json";
// import { ModosOp } from "../../../_comun/Constantes";

import ComandoBuscarUnItem from "./ComandoBuscarUnItem";

const DialogoInteractivoDeItem = ({ ventana }) => {
    const {
        // estadoPrin,
        // dispatchPrincipal,
        // cargarPantallaLogin,
        notificar,
    } = useContext(GlobalContext);

    const [estadoDCF, dispatchDCF] = useReducer(ItemReducer, ventana.estadoComp);
    ventana.estadoComp = estadoDCF;

    const registrarItemCommand = new ComandoRegistrarItem();
    // const registrarItemCommand = new Comando();
    registrarItemCommand.ejecutar = useHandlerDeComandoConSesionActiva(async () => {
        const item = {
            tipoItem: estadoDCF.domain.screen.tipoItem,
            nombre: estadoDCF.domain.screen.nombre,
            descripcion: estadoDCF.domain.screen.descripcion,
            precio: estadoDCF.domain.screen.precio,
            moneda: estadoDCF.domain.screen.moneda,
            udm: estadoDCF.domain.screen.udm,
        };

        try {
            // const servicio = new ServicioRegistroDeItem();
            // registrarItemCommand.servicio = servicio;

            // const dataRegistradaDeItem = await servicio.ejecutar(item);
            const dataRegistradaDeItem = await registrarItemCommand.servicio.ejecutar(item);
            // await new ServicioRegistroDeClienteAFacturar().ejecutar(item);
            dispatchDCF(new Action.CargaDeItemRegistrado(dataRegistradaDeItem));
            notificar(
                new NotificacionToastDeCreacion(
                    DataDeRespuestas_Facturacion.CreacionClienteAFacturar.titulo,
                    DataDeRespuestas_Facturacion.CreacionClienteAFacturar.mensaje,
                    dataRegistradaDeItem.idItem
                )
            );
        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                dispatchDCF(new Action.CargaDeErroresDelDominioAlCrearItem(error.data));
                return;
            }
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new Action.FinalizarComando());
            }
            throw error;
        }
    });

    const actualizarItemCommand = new ComandoActualizarItem();
    actualizarItemCommand.ejecutar = useHandlerDeComandoConSesionActiva(async () => {
        const itemPorActualizar = {
            id: estadoDCF.domain.screen.idItem,
            data: estadoDCF.domain.update,
        };

        try {
            // const servicio = new ServicioDeActualizacionDeItem();
            // actualizarItemCommand.servicio = servicio;
            // const dataDeClienteActualizado =
            await actualizarItemCommand.servicio.ejecutar(itemPorActualizar);
            dispatchDCF(
                new Action.CargaDeItemActualizado()
                // new Action.CargaDeClienteActualizado(dataDeClienteActualizado)
            );
        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchDCF(new Action.CargaDeErroresDelDominioAlActualizarItem(error.data));
                return;
            }
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new Action.FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                    /* new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError +
                            CodigoDeError[nombreDeError] +
                            "\n" +
                            DataDeRespuestas_Comun[nombreDeError].descripcion
                    ) */
                /*); */
            }
            throw error;
        }
    });

    const buscarUnSoloItemCommand = new ComandoBuscarUnItem();
    buscarUnSoloItemCommand.ejecutar = useHandlerDeComandoConSesionActiva(async (idItem) => {
        try {
            // const servicio = new ServicioDeQueryDeUnItem();
            // buscarUnSoloItemCommand.servicio = servicio;
            const respuestaQuery = await buscarUnSoloItemCommand.servicio.ejecutar(idItem);
            dispatchDCF(new CargaDeItemConsultado(respuestaQuery.item));
            // ventana.ventanaCargando.dispatch(new CargaDeClienteConsultado(respuestaQuery.cliente));
            // dispatchQ(new CargaDeClientesBuscados(respuestaQuery.clientes));
        } catch (error) {
            /* if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchQ(new Action.CargaDeErroresDelDominioAlActualizarCliente(error.data));
                return;
            }*/
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                ); */
            }
            throw error;
        }
    });

    return (
        <DialogItem
            ventana={ventana}
            estadoDCF={estadoDCF}
            dispatchDCF={dispatchDCF}
            // registrarClienteAFacturar={useHandlerDeServicio(registrarClienteAFacturar)}
            registrarItemCommand={registrarItemCommand}
            // actualizarClienteAFacturar={useHandlerDeServicio(actualizarClienteAFacturar)}
            actualizarItemCommand={actualizarItemCommand}
            // buscarUnSoloClienteAFacturar={buscarUnSoloClienteAFacturar}
            buscarUnSoloItemCommand={buscarUnSoloItemCommand}
        />
    );
};

export default DialogoInteractivoDeItem;
